import React, { useEffect, useState } from 'react';
import { CATEGORY_LABELS, IMPACT_LABELS, pad2 } from '../format';

// Ticked steps are remembered per report in this browser only. Storage can
// be unavailable (private mode, blocked site data), so every access is
// guarded and the checklist still works without it.
const loadDone = (key) => {
  try {
    return JSON.parse(window.localStorage.getItem(key)) || {};
  } catch {
    return {};
  }
};

const ActionPlan = ({ report, storageKey }) => {
  const [done, setDone] = useState(() => loadDone(storageKey));

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(done));
    } catch {
      // Not persisted; the checklist keeps working for this visit.
    }
  }, [done, storageKey]);

  const toggle = (id) => setDone((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <ol className="space-y-6">
      {report.actionPlan.map((action, i) => (
        <li
          key={i}
          className="rp-keep grid gap-6 rounded-[24px] border border-[var(--lp-line)] p-6 sm:p-8 md:grid-cols-[6rem_1fr]"
        >
          <span className="lp-display lp-outline text-6xl sm:text-7xl" aria-hidden="true">
            {pad2(i + 1)}
          </span>
          <div>
            <div className="flex flex-wrap gap-2 text-xs">
              <span className="rounded-full bg-[var(--lp-lime)] px-2.5 py-0.5 font-semibold text-[var(--lp-ink)]">
                {IMPACT_LABELS[action.impact]}
              </span>
              <span className="rounded-full border border-[var(--lp-line)] px-2.5 py-0.5">{action.effort}</span>
              <span className="rounded-full border border-[var(--lp-line)] px-2.5 py-0.5 text-[var(--lp-muted)]">
                {CATEGORY_LABELS[action.category]}
              </span>
            </div>
            <h3 className="mt-4 text-2xl font-semibold leading-tight tracking-[-0.02em]">
              <span className="sr-only">Paso {i + 1}: </span>
              {action.title}
            </h3>
            <p className="mt-2 leading-relaxed text-[var(--lp-muted)]">{action.why}</p>
            <ul className="mt-5 space-y-3">
              {action.steps.map((step, j) => {
                const id = `${i}-${j}`;
                const inputId = `step-${id}`;
                return (
                  <li key={id} className="flex gap-3">
                    <input
                      id={inputId}
                      type="checkbox"
                      className="rp-check"
                      checked={Boolean(done[id])}
                      onChange={() => toggle(id)}
                    />
                    <label htmlFor={inputId} className={`cursor-pointer leading-relaxed ${done[id] ? 'rp-step-done' : ''}`}>
                      {step}
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        </li>
      ))}
    </ol>
  );
};

export default ActionPlan;
